import {
  Accordion as MuiAccordion,
  accordionClasses,
  accordionSummaryClasses,
  AccordionSummary,
  styled,
  AccordionDetails,
} from '@ori-ui/mui';

export const StyledMuiAccordion = styled(MuiAccordion)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  '&::before': {
    display: 'none',
  },
  [`&.${accordionClasses.expanded}`]: {
    margin: theme.spacing(0, 0, 3),
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  border: 'none',
  minHeight: '48px !important',
  padding: 0,
  [`& .${accordionSummaryClasses.content}`]: {
    margin: '0 !important',
    padding: 0,
  },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(() => ({
  padding: 0,
}));
